// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pack-list {
  padding: var(--spacing-half) var(--spacing-quarter);
}

.participants {
  display: flex;
  gap: 0 var(--spacing);
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .participants {
    margin-top: var(--spacing-half);
    flex-direction: column;
    flex-wrap: nowrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/general-components/pack-overview/pack-overview.component.scss"],"names":[],"mappings":"AACA;EACI,mDAAA;AAAJ;;AAGA;EACI,aAAA;EACA,qBAAA;EACA,eAAA;AAAJ;AAEI;EALJ;IAMQ,+BAAA;IACA,sBAAA;IACA,iBAAA;EACN;AACF","sourcesContent":["\n.pack-list{\n    padding: var(--spacing-half) var(--spacing-quarter);\n}\n\n.participants {\n    display: flex;\n    gap: 0 var(--spacing);\n    flex-wrap: wrap;\n\n    @media (max-width: 768px) {\n        margin-top: var(--spacing-half);\n        flex-direction: column;\n        flex-wrap: nowrap;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
